import api from '../api';

export function listMedia(accountId) {
    return api.get(`/media?account_id=${accountId}`).then(response => response.data);
}

export function getMedia(mediaId) {
    return api.get(`/media/${mediaId}`).then(response => response.data);
}

export function removeMedia(mediaId) {
    return api.delete(`/media/${mediaId}`);
}

export function downloadMedia(mediaId) {
    return api.get(`/media/${mediaId}/download`).then(response => response.data);;
}
